(() => {
  const KEY = "wishlist_handles_v2";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch { return []; }
  };

  const write = (list) => localStorage.setItem(KEY, JSON.stringify(list));

  const has = (handle) => read().includes(handle);

  const add = (handle) => {
    const list = read();
    if (!list.includes(handle)) list.push(handle);
    write(list);
    return list;
  };

  const remove = (handle) => {
    const list = read().filter(h => h !== handle);
    write(list);
    return list;
  };

  const count = () => read().length;

  const updateCountBadges = () => {
    const c = count();
    document.querySelectorAll("[data-wishlist-count]").forEach(el => {
      el.textContent = String(c);
      el.hidden = c === 0;
    });
  };

  const syncButtons = () => {
    document.querySelectorAll("[data-wishlist-btn][data-product-handle]").forEach(btn => {
      const handle = btn.getAttribute("data-product-handle");
      const active = handle ? has(handle) : false;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  };

  const emit = () => {
    document.dispatchEvent(new CustomEvent("wishlist:updated", {
      detail: { list: read(), count: count() }
    }));
  };

  const toggle = (handle) => {
    if (!handle) return;
    const list = has(handle) ? remove(handle) : add(handle);
    updateCountBadges();
    syncButtons();
    emit();
    return list;
  };

  // click handler (works everywhere)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-btn]");
    if (!btn) return;

    e.preventDefault();
    const handle = btn.getAttribute("data-product-handle");
    toggle(handle);
  });

  // expose API for wishlist page
  window.Wishlist = {
    read, write, has, toggle, count,
    updateCountBadges, syncButtons
  };

  document.addEventListener("DOMContentLoaded", () => {
    updateCountBadges();
    syncButtons();
  });
})();
